import React from "react";
import { Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchButton({
  onClick,
  text = "Search",
  variant = "contained",
  color = "primary",
  size = "medium",
  startIcon = <SearchIcon />,
  sx = {},
  ...props
}) {
  return (
    <Button
      variant={variant}
      color={color}
      size={size}
      startIcon={startIcon}
      onClick={onClick}
      sx={{
        borderRadius: 1,
        textTransform: "none",
        fontWeight: "medium",
        px: 3,
        bgcolor: color === "primary" ? "#FF8A65" : undefined,
        "&:hover": {
          bgcolor: color === "primary" ? "#FF7043" : undefined,
        },
        ...sx,
      }}
      {...props}
    >
      {text}
    </Button>
  );
}